import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
    contextField: {
        minWidth: '140px',
    },
    operator: {
        minWidth: '105px',
    },
});
